import Banner from './Banner';
import Service from './Service';
import Footer from '../Footer/Footer';

const Home = () => {
    return (
        <>
        
            <Banner />
            <Service />
            <Footer/>
        </>
    )
}

export default Home